// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xGoX","delete":"styles_delete__3P03h","update":"styles_update__162yn","add":"styles_add__2XTjS"};